import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { Cliente } from '../../../core/models/clientes/cliente';

/**
 * Bloco "Cliente (Selecionado)" do Step 0 (Cabeçalho) do wizard de pedidos:
 * alerta de cliente bloqueado, resumo do cliente selecionado (código, nome,
 * endereço, CNPJ/CPF, status financeiro/Notas Fiscais) e segmentação do
 * cliente (pedidos-cadastro.component.html:749-841).
 *
 * Boundary real: começa em html:749 (`clienteSelecionado.bloqueado === 1`)
 * e vai até html:841 (`<hr class="mt-2 mb-2" />` que fecha visualmente o
 * bloco de segmentação) — imediatamente antes do `<!-- Orçamento/Pedido -->`
 * de html:843, que abre o escopo da Task 3.
 *
 * Botão "Locais de Entrega": verificado via grep (`grep -n "Locais de
 * Entrega\|modalLocaisEntrega\|locaisEntregaModal"`) — única ocorrência
 * permanece em html:707-708, 100% dentro do bloco da Task 1
 * (`app-pedido-cliente-busca`). Não há segunda ocorrência para o caso de
 * edição de pedido existente, então este componente NÃO reimplementa o
 * gatilho de Locais de Entrega.
 *
 * Animação: bloco verificado (`grep -n "@esvanecerDesvanecer\|@desvanecer"`
 * nas linhas 749-841) — nenhuma ocorrência. Sem dependência de `Animacao`
 * aqui, diferente da Task 1.
 *
 * `<ng-template #notasFiscaisSinteticas>` referenciado pelo ícone de Notas
 * Fiscais (html:783) permanece no pai (html:358) — recebido aqui via
 * @Input() `modalNotasFiscais`, mesmo padrão de `modalLocaisEntrega` da
 * Task 1. O call site real é `modalNotasFiscaisSinteticas(notasFiscaisSinteticas,
 * clienteSelecionado.client_document)` (ts:9000) — o `client_document` é
 * reconstruído pelo pai a partir de `clienteSelecionado` (já recebido como
 * @Input() aqui) no momento do wiring (Task 4); este componente reemite
 * apenas o TemplateRef, conforme especificado no brief.
 *
 * Componente puramente apresentacional: nenhuma ação de negócio é executada
 * aqui, apenas reemitida via @Output() para o pai (wiring na Task 4).
 */
@Component({
  selector: 'app-pedido-cliente-selecionado',
  standalone: false,
  templateUrl: './pedido-cliente-selecionado.component.html',
  styleUrls: ['./pedido-cliente-selecionado.component.scss']
})
export class PedidoClienteSelecionadoComponent {
  @Input() clienteSelecionado: Cliente = null;

  /** Gate de erro de validação (html:760, 764-767, 773, 777, 787) — real: ts:188 (`clienteInvalido`). */
  @Input() clienteInvalido = false;

  /** TemplateRef do modal de Notas Fiscais Sintéticas (`#notasFiscaisSinteticas` no pai, html:358). */
  @Input() modalNotasFiscais: TemplateRef<any> = null;

  @Output() abrirNotasFiscais = new EventEmitter<TemplateRef<any>>();
}
